export const columns = [
  { key: 'name', title: 'Name' },
  { key: 'role', title: 'Role' },
  { key: 'cost', title: 'Cost' },
  { key: 'currentLocation', title: 'Current Location' },
  { key: 'timeAtLocation', title: 'Time at Location' },
  { key: 'arrival', title: 'Arrival' },
  { key: 'departure', title: 'Departure' },
  { key: 'totalTimeOnSite', title: 'Total Time on Site' },
];

export const marks = [
  {
    value: 2,
    label: '6 AM',
  },
  {
    value: 10,
    label: '7 AM',
  },
  {
    value: 18,
    label: '8 AM',
  },
  {
    value: 26,
    label: '9 AM',
  },
  {
    value: 34,
    label: '10 AM',
  },
  {
    value: 42,
    label: '11 AM',
  },
  {
    value: 50,
    label: '12 PM',
  },
  {
    value: 58,
    label: '1 PM',
  },
  {
    value: 66,
    label: '2 PM',
  },
  {
    value: 74,
    label: '3 PM',
  },
  {
    value: 82,
    label: '4 PM',
  },
  {
    value: 90,
    label: '5 PM',
  },
  {
    value: 98,
    label: '6 PM',
  },
];

export const smMarks = [
  {
    value: 2,
    label: '6 AM',
  },
  {
    value: 18,
    label: '8 AM',
  },
  {
    value: 34,
    label: '10 AM',
  },
  {
    value: 50,
    label: '12 PM',
  },
  {
    value: 66,
    label: '2 PM',
  },
  {
    value: 82,
    label: '4 PM',
  },
  {
    value: 98,
    label: '6 PM',
  },
];

export const xsMarks = [
  {
    value: 2,
    label: '6 AM',
  },
  {
    value: 26,
    label: '9 AM',
  },
  {
    value: 50,
    label: '12 PM',
  },
  {
    value: 74,
    label: '3 PM',
  },
  {
    value: 98,
    label: '6 PM',
  },
];
